import React, { useState } from 'react';
import { ChevronDown, Menu, X, Code, Smartphone, Globe,Cog, Users, TrendingUp, Shield, Zap, ArrowRight,
   CheckCircle, Star, DollarSign, PieChart, FileText, Eye, Clock, Calculator, Briefcase, Target, Lock, CreditCard, Database, Server,Building2, Award  } from 'lucide-react';
import Header from "./header";
import Footer from "./footer";
export default function PaymentGatewayStaffAugmentation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
    companyName: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Consultation request submitted! Our payment gateway specialists will contact you soon.');
    setFormData({
      fullName: '',
      phoneNumber: '',
      email: '',
      companyName: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-white">
        <style jsx>{`
        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        @keyframes spinSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        .animate-fade-in-left {
          animation: fadeInLeft 0.8s ease-out forwards;
        }
        
        .animate-fade-in-right {
          animation: fadeInRight 0.8s ease-out forwards;
        }
        
        .animate-spin-slow {
          animation: spinSlow 8s linear infinite;
        }
      `}</style>
      {/* Header */}
      <Header />
        {/* Hero Section - Light */}
      <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-cyan-50 py-20 relative overflow-hidden">
        <div className="absolute top-10 right-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-16 h-16 bg-indigo-200 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-cyan-200 rounded-full opacity-40 animate-pulse"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-blue-100 rounded-full text-blue-700 text-sm font-medium mb-6">
                <Award className="h-4 w-4 mr-2" />
                Bank Grade Security Certified Professionals
              </div>
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Scale Your Payment Gateway with
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                  Expert FinTech Talent
                </span>
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                Access specialized payment gateway developers, security architects, and compliance professionals. 
                Build secure, scalable, and PCI-compliant payment solutions with our vetted global talent pool 
                deployed in 24 hours.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-full text-lg font-medium hover:shadow-lg hover:scale-105 transition-all duration-200">
                  Get Payment Experts in 24h
                </button>
                <button className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-full text-lg font-medium hover:bg-blue-50 transition-colors">
                  Schedule Free Consultation
                </button>
              </div>
              <div className="flex items-center space-x-6 text-sm text-gray-600">
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  No Setup Fees
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  100% Compliance Guaranteed
                </div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                  24/7 Support
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white rounded-3xl shadow-2xl p-8 transform hover:scale-105 transition-transform duration-300">
                <div className="bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl p-6 text-white mb-6">
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <div className="text-sm text-blue-200 mb-1">Available Payment Experts</div>
                      <div className="text-3xl font-bold">150+</div>
                    </div>
                    <div className="bg-white/20 p-2 rounded-lg">
                      <CreditCard className="h-6 w-6" />
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-xs">
                    <div className="text-center">
                      <div className="font-semibold">Security</div>
                      <div className="text-blue-200">Bank Grade Security</div>
                    </div>
                    <div className="text-center">
                      <div className="font-semibold">API</div>
                      <div className="text-blue-200">Integration</div>
                    </div>
                    <div className="text-center">
                      <div className="font-semibold">Fraud</div>
                      <div className="text-blue-200">Prevention</div>
                    </div>
                  </div>
                </div>
                <div className="space-y-4">
                  <div className="flex justify-between items-center p-4 bg-green-50 rounded-xl hover:bg-green-100 transition-colors">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <Shield className="h-5 w-5 text-green-600" />
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900">Security Architect</div>
                        <div className="text-sm text-gray-600">Bank Grade Security & Fraud Prevention</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-green-600 font-semibold text-sm">Available</div>
                      <div className="text-xs text-gray-500">Senior Level</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <Code className="h-5 w-5 text-blue-600" />
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900">Payment API Engineer</div>
                        <div className="text-sm text-gray-600">Gateway Integration Specialist</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-blue-600 font-semibold text-sm">Available</div>
                      <div className="text-xs text-gray-500">Lead Level</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-purple-50 rounded-xl hover:bg-purple-100 transition-colors">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                        <Database className="h-5 w-5 text-purple-600" />
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900">Compliance Officer</div>
                        <div className="text-sm text-gray-600">Regulatory & Risk Management</div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-purple-600 font-semibold text-sm">Available</div>
                      <div className="text-xs text-gray-500">Expert Level</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section - Dark */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 text-center">
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">24h</div>
              <div className="text-gray-300 text-sm">Expert Deployment Time</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">150+</div>
              <div className="text-gray-300 text-sm">FinTech Professionals</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">99.9%</div>
              <div className="text-gray-300 text-sm">Bank Grade Security Compliance Rate</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">60%</div>
              <div className="text-gray-300 text-sm">Faster Time-to-Market</div>
            </div>
            <div className="group hover:transform hover:scale-105 transition-all duration-200">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400 mb-2">24/7</div>
              <div className="text-gray-300 text-sm">Security Monitoring</div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Models Section - Light */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Choose Your Payment Gateway Engagement Model
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Flexible engagement models designed to meet your unique business needs and scale requirements
            </p>
          </div>

              <secti className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div className="animate-fade-in-left">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Build-Operate-Transfer (BOT) Model
                </h2>
                <p className="text-base text-gray-600 mb-4">
                  A proven operational strategy helping establish high-performing teams with minimal risk. Anvitech handles everything from business analysis to infrastructure setup.
                </p>
                <p className="text-base text-gray-600">
                  Offers clear exit path to ownership, ideal for minimizing startup risks while maximizing long-term value creation.
                </p>
              </div>
              <div className="flex justify-center animate-fade-in-right">
                <div className="relative group">
                  <div className="w-64 h-64 bg-gradient-to-br from-teal-400 to-blue-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                      <Cog className="w-24 h-24 text-teal-500 animate-spin-slow" />
                    </div>
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full animate-bounce"></div>
                  <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-pink-400 rounded-full animate-pulse"></div>
                </div>
              </div>
            </div>
          </div>
        </secti>

        {/* POD Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div className="md:order-2 animate-fade-in-right">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">POD</h2>
                <p className="text-base text-gray-600 mb-4">
                  Our Synergy POD Model enables businesses to scale with precision. PODs tailored to specific functions across shared services and technology delivery.
                </p>
                <p className="text-base text-gray-600">
                  Multi-transformation POD model elevates functional depth with platform-level foundational excellence.
                </p>
              </div>
              <div className="md:order-1 flex justify-center animate-fade-in-left">
                <div className="relative group">
                  <div className="w-64 h-64 bg-gradient-to-br from-green-400 to-teal-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                      <Target className="w-24 h-24 text-green-500 animate-pulse" />
                    </div>
                  </div>
                  <div className="absolute -top-2 -left-2 w-6 h-6 bg-purple-400 rounded-full animate-bounce" style={{animationDelay: '0.5s'}}></div>
                  <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-orange-400 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CaaS Section */}
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div className="animate-fade-in-left">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Captive-as-a-Service (CaaS) Model
                </h2>
                <p className="text-base text-gray-600 mb-4">
                  Get captive benefits without operational complexity. Anvitech provides comprehensive services to setup, operate, and optimize captives on your behalf.
                </p>
                <p className="text-base text-gray-600">
                  Perfect for organizations seeking speed to scale, cost efficiency, and enhanced operational agility with end-to-end services.
                </p>
              </div>
              <div className="flex justify-center animate-fade-in-right">
                <div className="relative group">
                  <div className="w-64 h-64 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                      <Globe className="w-24 h-24 text-blue-500 animate-spin-slow" />
                    </div>
                  </div>
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-400 rounded-full animate-bounce" style={{animationDelay: '0.3s'}}></div>
                  <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-red-400 rounded-full animate-pulse" style={{animationDelay: '0.8s'}}></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* GCC Section */}
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-10 items-center">
              <div className="md:order-2 animate-fade-in-right">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">GCC</h2>
                <p className="text-base text-gray-600 mb-4">
                  Transform Global Capability Centers from cost centers to strategic innovation hubs. GCC-based product development and tech transformation drive competitive advantage.
                </p>
                <p className="text-base text-gray-600">
                  Comprehensive solutions spanning technology, operations, and execution strategies to ensure value and drive unprecedented outcomes.
                </p>
              </div>
              <div className="md:order-1 flex justify-center animate-fade-in-left">
                <div className="relative group">
                  <div className="w-64 h-64 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                    <div className="w-48 h-48 bg-white rounded-full flex items-center justify-center">
                      <Users className="w-24 h-24 text-purple-500 animate-pulse" />
                    </div>
                  </div>
                  <div className="absolute -top-2 -left-2 w-6 h-6 bg-blue-400 rounded-full animate-bounce" style={{animationDelay: '0.7s'}}></div>
                  <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-yellow-400 rounded-full animate-pulse" style={{animationDelay: '1.2s'}}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Roles Section - Dark */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Access Specialized Payment Gateway Talent</h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto">
              Our curated network of FinTech professionals brings deep expertise across all aspects of payment 
              gateway development, security, and compliance to accelerate your digital payment initiatives.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {[
              { icon: Shield, label: 'Security Engineers', color: 'blue' },
              { icon: CreditCard, label: 'Payment Architects', color: 'indigo' },
              { icon: Lock, label: 'Compliance Officers', color: 'purple' },
              { icon: Database, label: 'Fraud Analysts', color: 'pink' },
              { icon: Code, label: 'API Developers', color: 'green' },
              { icon: TrendingUp, label: 'Risk Managers', color: 'orange' }
            ].map((item, index) => (
              <div key={index} className="bg-gray-800 rounded-2xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 group hover:scale-105 border border-gray-700">
                <div className={`w-16 h-16 bg-gradient-to-br from-${item.color}-500 to-${item.color}-600 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform`}>
                  <item.icon className="h-8 w-8 text-white" />
                </div>
                <div className="text-sm font-semibold text-white">{item.label}</div>
                <div className="text-xs text-gray-400 mt-1">Available 24/7</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Solutions Section - Light */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Complete Payment Gateway Solutions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From development to deployment, our specialized teams deliver comprehensive payment gateway services
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-orange-500 to-red-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <Users className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Dedicated Payment Teams
              </h3>
              <div className="space-y-3 text-gray-600">
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-orange-500" />
                  Payment Gateway Developers
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-orange-500" />
                  Security & Compliance Experts
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-orange-500" />
                  API Integration Specialists
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-orange-500" />
                  Fraud Prevention Engineers
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-pink-500 to-purple-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <Shield className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Security & Compliance</h3>
              <div className="space-y-3 text-gray-600">
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-pink-500" />
                  Bank Grade Security Implementation
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-pink-500" />
                  Penetration Testing
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-pink-500" />
                  Regulatory Compliance
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-pink-500" />
                  Risk Assessment
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="bg-gradient-to-r from-green-500 to-emerald-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <Server className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Infrastructure Management</h3>
              <div className="space-y-3 text-gray-600">
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-green-500" />
                  Payment Processing Infrastructure
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-green-500" />
                  Load Balancing & Scaling
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-green-500" />
                  Database Optimization
                </div>
                <div className="flex items-center">
                  <ArrowRight className="w-4 h-4 mr-3 text-green-500" />
                  24/7 Monitoring
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 bg-gray-900 relative overflow-hidden">
        <img src='./security.jpg' alt="Background Frame" className="absolute inset-0 w-full h-full object-cover" />
      </section>
      {/* CTA Section - Dark */}
      <section className="py-20 bg-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-indigo-900/20"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Scale Your Payment Gateway Team?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Get access to top-tier FinTech talent within 24 hours. Our experts are ready to help you build 
              secure, compliant, and scalable payment solutions.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/Contact" className="flex items-center">
              <button className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-full text-lg font-medium hover:shadow-lg hover:scale-105 transition-all duration-200">
                Start Your Project Today
              </button>
              </a>
              {/* <button className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-white hover:text-gray-900 transition-colors">
                Schedule a Free Consultation
              </button> */}
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
} 
